import { defineStore } from 'pinia';
import { notify } from 'notiwind';

export const useWalletStore = defineStore('wallet', {
    state: () => ({
        activeAccount: {},
        banks: [],
        cards: [],
        filters: {
            card_status: [],
            account_type: [],
            all_cards: ['Y'],
            ignore: false,
        },
        hasConnections: null,
        institution: '',
        loaded: false,
        loadingMembers: false,
        members: [],
        onboarded: true,
        selectedCard: null,
        selectedUser: null,
        accountToEdit: null,
        showAccountSidebar: false,
        showAddUserModal: false,
        showEditCardModal: false,
        showCopyCardModal: false,
        wallet: {
            id: 0,
            user_id: 0,
        },
        walletId: 0,
        users: [],
        features: {},
    }),
    getters: {
        myWallet: (state) => state.wallet,
    },
    actions: {
        getWallet() {
            return ApiService.apiCall('/wallets', 'get')
                .then((response) => {
                    this.setLoaded(true);
                    this.setWallet(response.data.wallet);
                    // this.wallet.id = response.data.wallet.id;
                    this.hasConnections = response.data.wallet.has_connections;
                    // this.setAppWalletId(response.data.wallet.id);
                    this.setWalletId(response.data.wallet.id);
                    this.setUsers(response.data.wallet.users);
                    // this.users = response.data.wallet.users;
                    // this.cards = response.data.cards;
                    this.setCards(response.data.cards);
                    this.setBanks(response.data.banks);
                    this.features = response.data.features;
                    // this.banks = response.data.banks;

                    // if (response.data.wallet.unresolved_cards.length > 0) {
                    //     this.unmatchCount =
                    //         response.data.wallet.unresolved_cards.length;
                    //     if (
                    //         !this.$cookies.get('matchaccounts') ||
                    //         response.data.wallet.has_new_accounts
                    //     ) {
                    //         this.showUnmatchedModal = true;
                    //     }
                    // }

                    // setTimeout(() => {
                    //     this.loadingWallet = false;
                    // }, 500);
                })
                .catch((response) => {
                    console.log(response);
                    //this.$root.handleHttpStatus(response);
                    this.loadingWallet = false;
                });
        },

        getCards() {
            return ApiService.apiCall('/wallets/cards', 'get')
                .then((response) => {
                    this.setCards(response.data.cards);
                    return response.data.cards;
                })
                .catch((error) => {
                    notify(
                        {
                            group: 'error',
                            title: 'Error',
                            text: 'There was a problem trying to get your cards.',
                        },
                        4000
                    );
                    return [];
                });
        },
        setWallet(data) {
            this.wallet = data;
        },
        setWalletId(data) {
            this.walletId = data;
        },
        setInstitution(data) {
            this.instituion = data;
        },
        setUsers(data) {
            this.users = data;
        },
        setCards(data) {
            this.cards = data;
        },
        setAccountSidebar(show) {
            this.showAccountSidebar = show;
            if (!show) {
                this.activeAccount.sidebarOpen = false;
                setTimeout(() => {
                    this.activeAccount = {};
                }, 500);
            }
        },
        setActiveAccount(account) {
            this.activeAccount = account;
        },
        setOnboarded(val) {
            this.onboarded = val;
        },
        setLoaded(val) {
            this.loaded = val;
        },
        setBanks(data) {
            this.banks = data;
        },
        setShowAddUserModal(val) {
            this.showAddUserModal = val;
        },
        setShowEditCardModal(val) {
            this.showEditCardModal = val;
        },
        setSelectedCard(val) {
            this.selectedCard = val;
        },
        setAccountToEdit(accountGuid) {
            // Store the card ID to edit - will be picked up by the wallet component
            // This is a temporary flag that should be cleared after use
            this.accountToEdit = accountGuid;
        },
        clearAccountToEdit() {
            this.accountToEdit = null;
        },
        setSelectedUser(val) {
            this.selectedUser = val;
        },
        deleteCard(card) {
            ApiService.apiCall(
                '/wallets/' + this.walletId + '/cards/' + card.id,
                'delete'
            )
                .then(() => {
                    notify(
                        {
                            group: 'success',
                            title: 'Success',
                            text: 'Your card has been removed from your wallet!',
                        },
                        6000
                    );

                    this.users.forEach((user, i) => {
                        user.institutions.forEach((ins, ii) => {
                            ins.accounts.forEach((account, k) => {
                                if (card.id === account.id) {
                                    this.users[i].institutions[
                                        ii
                                    ].accounts.splice(k, 1);
                                }
                            });
                        });
                    });
                })
                .catch((response) => {
                    console.log(response);
                    this.$root.handleHttpStatus(response);
                });
        },

        setFilters(key, val) {
            this.filters[key] = val;
        },
        removeFilter(key, index) {
            this.filters[key].splice(index, 1);
        },
        resetFilters() {
            this.filters = {
                card_status: [],
                account_type: [],
                all_cards: ['Y'],
                ignore: false,
            };
        },
        updateCard(data) {
            return ApiService.apiCall(
                '/wallets/' + this.wallet.id + '/cards/' + data.id,
                'put',
                { card: data }
            ).then((response) => {
                this.getWallet();
                return response;
            });
        },

        setShowCopyCardModal(show) {
            this.showCopyCardModal = show;
        },
    },
});
